define('rebrush/components/product/view/specifications',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'cartware/components/Registry',
	'modernizr',
	'elevatezoom',
	'cartware-slider',
	'magnific-popup'
], function(
	$,
	_,
	Component,
	BEM,
	Registry
) {
	var cache = {
		blocks: {}
	};

	return Component.create({
		cache:			null,
		block:			null,
		thumbs:			null,
		galleryImages:	null,
		galleryElement:	null,

		onSimpleChangeCallback:	null,

		constructor: function() {
			this.onSimpleChangeCallback = _.bind(function(e, simple) {
				this.changeSimple(simple);
			}, this);
		},

		$init: function() {
			this.initializeComponent();

			this.cache = {
				blocks: {
					'__initial': this.block
				}
			};

			this.initializeSimpleObservation();
		},

		initializeComponent: function() {
			this.block = BEM.block('product-detail-specifications');
		},

		initializeSimpleObservation: function() {
			var currentSimple = _.get(window, 'spConfig.__currentSimple');

			$(document).on('product/changeSimple', this.onSimpleChangeCallback);

			if (currentSimple) {
				this.changeSimple(currentSimple);
			}
			//$(document).on('product/changeGallerySimple', _onChange);
		},

		changeSimple: function(simple) {
			var block;

			if (!simple) {
				block = this.cache.blocks.__initial;
			} else {
				if (!(simple.id in cache.blocks)) {
					cache.blocks[simple.id] = $('<div/>').append(simple.specifications);
				}

				block = cache.blocks[simple.id];
			}

			//this.block.replaceWith(block);
			block.replaceAll(this.block);
			this.block = block;

			this.block.trigger('gigaset.content.change');
		},

		destructor: function() {
			$(document).off('product/changeSimple', this.onSimpleChangeCallback);
		}
	});
});
